<template>
  <a-modal
          title="机构考核证书到期提醒"
          okText="确认"
          cancelText="取消"
          width="800px"
          :visible="visible"
          :confirm-loading="confirmLoading"
          @ok="handleOk"
          @cancel="handleCancel"
  >
    <a-form-model ref="ruleForm" :model="formState" :rules="rules" :label-col="{span:8}" :wrapper-col="{span:16}">
      <a-row>
        <a-col span="12">
          <a-form-model-item label="机构代码" prop="code">
            <a-ext-bold-a v-model="formState.code"></a-ext-bold-a>
          </a-form-model-item>
        </a-col>

        <a-col span="12">
          <a-form-model-item label="检测机构名称" prop="name">
            <a-ext-bold-a v-model="formState.name"></a-ext-bold-a>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="12">
          <a-form-model-item label="所属区域" prop="xzqhName">
            <a-ext-bold-a v-model="formState.regionName"></a-ext-bold-a>
          </a-form-model-item>
        </a-col>

        <a-col span="12">
          <a-form-model-item label="机构联系方式" prop="orgTel">
            <a-ext-bold-a v-model="formState.orgTel"></a-ext-bold-a>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="法定代表人" prop="bossName">
            <a-ext-bold-a v-model="formState.bossName"></a-ext-bold-a>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="机构所在地址" prop="address">
            <a-ext-bold-a v-model="formState.address"></a-ext-bold-a>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="12">
          <a-form-model-item label="联系人" prop="connectName">
            <a-ext-bold-a v-model="formState.connectName"></a-ext-bold-a>
          </a-form-model-item>
        </a-col>

        <a-col span="12">
          <a-form-model-item label="联系人电话" prop="connectTel">
            <a-ext-bold-a v-model="formState.connectTel"></a-ext-bold-a>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="许可决定日期" prop="accessJudgeDate">
            <a-ext-bold-a v-model="formState.accessJudgeDate"></a-ext-bold-a>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="12">
          <a-form-model-item label="有效期自" prop="accessStartDate">
            <a-ext-bold-a v-model="formState.accessStartDate"></a-ext-bold-a>
          </a-form-model-item>
        </a-col>

        <a-col span="12">
          <a-form-model-item label="有效期至" prop="accessEndDate">
            <a-ext-bold-a v-model="formState.accessEndDate"></a-ext-bold-a>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="距到期时间" prop="dateDepart">
            <a-ext-bold-a v-model="formState.datePart.replace('-','已超期')+'天'"></a-ext-bold-a>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col span="24">
          <a-button type="primary" @click="onAlertSetModalOpen(formState)">发布短信通知</a-button>
        </a-col>
      </a-row>
    </a-form-model>
    <alert-set-modal v-if="alertSetModalVisable" :visible.sync="alertSetModalVisable" :param="alertSetModalParam"
                     @addModalClose="onAlertSetModalClose"></alert-set-modal>
  </a-modal>
</template>

<script>
import AlertSetModal from './AlertSetModal'
import AExtBoldA from '../../../components/AntDesignExt/All/AExtBoldA'
import {getDaoQiAlertInfo as initApi,addorUpdateOCheckerCardMsgSend as sendMsgApi} from '../../../api/api'

export default {
    name: "FormModel",
    components: {
        AExtBoldA, AlertSetModal,
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        param: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            confirmLoading: false,
            formState: {
                code: '',
                name: '',
                region_name: '',
                org_tel: '',
                boss_name: '',
                address: '',
                connect_name: '',
                connect_tel: '',
                access_judge_date: '',
                access_start_date: '',
                access_end_date: '',
                date_part: '',
            },
            rules: {},
            alertSetModalVisable: false,
            alertSetModalBackChange: null,
            alertSetModalParam: null
        };
    },
    created() {
        this.initForm();
    },
    methods: {
        initForm() {
            if (this.param.id) {
                this.confirmLoading = true;
                initApi(this.param).then((result => {
                    this.formState = result.data.data;
                    this.confirmLoading = false;
                })).catch(() => {
                    this.confirmLoading = false;
                });
            }
        },
        handleOk(e) {
            this.$emit("update:visible", false)
        },
        handleCancel(e) {
            this.$emit("update:visible", false)
        },
        onAlertSetModalOpen(record) {
            // this.alertSetModalParam = {id: record.id};
            // this.alertSetModalVisable = true;
            sendMsgApi({cardId:record.id,accessEndDate:record.accessEndDate,manualSend:'手工'}).then((result => {
                this.formState = result.data.data;
                if(result.data.data===true)
                {
                    this.success()
                }
            })).catch(() => {

            });
        },
        onAlertSetModalClose() {
            //TODO: 无
        },
        success(updateItem) {
            this.$message.success(
                '操作成功',
                2,
            );
        },
    },
}
</script>

<style scoped lang="scss">

  /deep/ .ant-modal-body {
    /*height: 60vh;*/
    /*overflow-y: scroll;*/
  }

</style>